import React from 'react';

import { termsOfService } from '../../content/legal';
import LegalPage, { LegalContent } from '../LegalPage/LegalPage';

// The Terms of Service, rendered from the copy held in src/content/legal.
const TermsOfServicePage = () => (
  <LegalPage doc={termsOfService} currentPage="TermsOfServicePage" />
);

// The same document without the page chrome, for use inside modals.
const TermsOfServiceContent = () => <LegalContent doc={termsOfService} />;

export { TermsOfServiceContent };

export default TermsOfServicePage;
